import React from 'react';
import * as PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";

class LayoutName extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenDialog: false,
            layoutName: this.props.layoutName
        };

        this.closeDialog = this.closeDialog.bind(this);
        this.onChangeTextField = this.onChangeTextField.bind(this);
        this.onClickDecide = this.onClickDecide.bind(this);
        this.onClickTextField = this.onClickTextField.bind(this);
        this.onEnterDialog = this.onEnterDialog.bind(this);
    }

    closeDialog() {
        this.setState({isOpenDialog: false});
    }

    onChangeTextField(event) {
        this.setState({layoutName: event.target.value});
    }

    onClickDecide() {
        this.setState({isOpenDialog: false}, () => {
            this.props.onClickDecideChange(this.state.layoutName);
        });
    }

    onClickTextField() {
        this.setState({isOpenDialog: true})
    }

    onEnterDialog() {
        this.setState({layoutName: this.props.layoutName});
    }

    static isEmptyStringAfterTrim(value) {
        // 空の文字列もしくは半角スペースのみの場合,true.
        return value.trim() === '';
    }

    render() {
        return (
            <div>
                <div onClick={this.onClickTextField}>
                    <TextField
                        label={"レイアウト名"}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        value={this.props.layoutName}
                        InputProps={{readOnly: true}}
                        disabled = {this.props.isDisabled}
                    />
                </div>
                <Dialog
                    maxWidth={"xs"}
                    fullWidth
                    open={this.state.isOpenDialog}
                    onClose={this.closeDialog}
                    onEnter={this.onEnterDialog}
                    style={{textAlign: "center"}}
                >
                    <DialogTitle>レイアウト名</DialogTitle>
                    <DialogContent>
                        <FormControl variant="outlined">
                            <TextField
                                variant="outlined"
                                fullWidth
                                value={this.state.layoutName}
                                onChange={this.onChangeTextField}
                                error={LayoutName.isEmptyStringAfterTrim(this.state.layoutName)}
                                helperText={LayoutName.isEmptyStringAfterTrim(this.state.layoutName) ? '1文字以上で入力してください。' : ''}
                                autoFocus
                            />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button fullWidth onClick={this.closeDialog} color="secondary" variant="contained">キャンセル</Button>
                        <Button fullWidth onClick={this.onClickDecide} color="primary" variant="contained" disabled={LayoutName.isEmptyStringAfterTrim(this.state.layoutName)}>決定</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

LayoutName.propTypes = {
    layoutName: PropTypes.string.isRequired,
    onClickDecideChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
};

export default LayoutName;
